// extracted by mini-css-extract-plugin
export default {"spinner":"CountriesList_spinner__staQz"};